import { usePusherChannel, usePusherEvents } from '@assembly-web/pusher';
import { datadogLogs } from '@datadog/browser-logs';
import { useSearchParams } from 'react-router-dom';

import { useActionBarQuery } from '../useActionBarQuery';
import { useUserDetails } from '../useUserDetails';

export function useActionBarUpdatesEvents() {
  const [params] = useSearchParams();
  const filter = params.get('filter');

  const { refetch } = useActionBarQuery({
    enabled: (filter && filter === 'all') || !filter,
  });

  const { data: userDetails } = useUserDetails();

  const channel = usePusherChannel(
    `private-member-${userDetails?.member.memberId}`
  );

  const assembly = usePusherChannel(
    `private-assembly-${userDetails?.assembly.assemblyId}`
  );

  const flowEvents = ['NEW_FLOW_RESPONSE', 'FLOW_ARCHIVED', 'FLOW_UNARCHIVED'];

  const assemblyEvents = [
    'FLOW_PUBLISHED',
    'OCCURRENCE_ENDED',
    'OCCURRENCE_CREATED',
    'SHARE_REQUEST_APPROVED',
    'ASSEMBLY_MEMBER_DEACTIVATED',
  ];

  usePusherEvents(channel, flowEvents, async () => {
    try {
      await refetch();
    } catch (e) {
      datadogLogs.logger.error(
        'Refetch error on new flow events',
        {},
        e as Error
      );
    }
  });

  usePusherEvents(assembly, assemblyEvents, async () => {
    try {
      await refetch();
    } catch (e) {
      datadogLogs.logger.error(
        'Refetch error on new flow events',
        {},
        e as Error
      );
    }
  });
}
